import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { BrowserRouter as Router } from 'react-router-dom';

import Homepage from './homepage'
import Details from './details'
import Payment from './payment'
import CardDetails from './card-details'
import CardReader from './card-reader'
import CardReaderConfirm from './card-reader-confirm'
import RegularBilling from './regular-billing'
import Thanks from './thanks'
import Failed from './failed'

import ScrollToTop from '../components/scroll-to-top'

const Views: React.FC = (props: any) => {

  const membership_form = (window as any).KEW.collections.membership_form[0]
  const privateForm = membership_form.private_form ? '/private' : ''

  return (
    <main className="row" id="main" tabIndex={-1}>
      <div className="columns large-12">
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path={`/membership${privateForm}/:url`} element={<Homepage {...props} />} />
            <Route path={`/membership${privateForm}/:url/details`} element={<Details {...props} />} />
            <Route path={`/membership${privateForm}/:url/payment`} element={<Payment {...props} />} />
            <Route path={`/membership${privateForm}/:url/card-details`} element={<CardDetails {...props} />} />
            <Route path={`/membership${privateForm}/:url/card-reader`} element={<CardReader {...props} />} />
            <Route path={`/membership${privateForm}/:url/card-reader/confirm/:id`} element={<CardReaderConfirm {...props} />} />
            <Route path={`/membership${privateForm}/:url/regular-billing`} element={<RegularBilling {...props} />} />
            <Route path={`/membership${privateForm}/:url/thanks`} element={<Thanks {...props} />} />
            <Route path={`/membership${privateForm}/:url/failed`} element={<Failed {...props} />} />
          </Routes>
        </Router>
      </div>
    </main>
  )
}

export default Views